import * as Yup from "yup";

export const SignInValidationSchema = Yup.object({
    email: Yup.string()
        .email("Please enter a valid email address")
        .required("Email Address is required")
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Please enter a valid email address'),
    password: Yup.string()
        .min(5, "Password must be 8 characters")
        .max(20, "Password cannot exceed 20 characters")
        .required("Password is required")
});


export const SignUpValidationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
        .email("Email is invalid")
        .required("Email is required")
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
        ),
    password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .max(20, "Password cannot exceed 20 characters")
        .required("Password is required"),
    termsAccepted: Yup.boolean()
        .oneOf([true], 'You must accept the terms and conditions')
        .required('You must accept the terms and conditions')
});

export const ForgotPasswordValidationSchema = Yup.object({
    email: Yup.string().email("Please enter a valid email address")
        .required("Email Address is required")
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Please enter a valid email address'),
})
